/**
 * 全部清除KeepAlive缓存
 * @param refName 定义的ref 名称
 * @returns {boolean}
 */
export function clearKeepAliveCaches(refName) {
  if (!refName) { return false }
  const parentObj = this.$refs[refName]?.$options?.parent;
  if (parentObj?.cache) {
    const { cache, keys } = parentObj
    // 遍历删除，或指定删除路由缓存
    keys.forEach(key => {
      delete cache[key];// 删除指定路由缓存
    })
    // 将值清空
    keys.splice(0, keys.length - 1);
  }
}

/**
 * 批量清除指定路由缓存
 * @param refName
 * @param nameList rms配置的路由name，要和页面的name一致,不一致不会缓存
 * @returns {boolean}
 */
export function clearItemKeepAliveCache(refName, nameList) {
  if (!refName || !nameList || nameList?.length < 1) { return false }
  // 先找最外层的是否有匹配缓存的页面
  const parentObj = this.$refs[refName]?.$options?.parent;
  cleanCacheAndKey(parentObj, nameList, 1)
  // 找子组件是否有匹配缓存的页面（最多两层路由）
  const childList = this.$refs[refName]?.$children
  if (childList?.length > 0) {
    childList.forEach(item => {
      const childObj = item?.$options?.parent
      cleanCacheAndKey(childObj, nameList, 2)
    })
  }
}

function cleanCacheAndKey(itemObj, nameList, level) {
  if(level > 4) { return false } // 最多找4层路由
  if (itemObj?.cache) {
    const { cache, keys } = itemObj
    if (keys?.length > 0) {
      // 遍历删除，或指定删除路由缓存。从后往前遍历数组，避免删除元素时影响索引
      for (let i = keys.length - 1; i >= 0; i--) {
        if (cache[keys[i]] && nameList.includes(cache[keys[i]]?.name)) {
          delete cache[keys[i]];// 删除指定路由缓存
          keys.splice(i, 1)
        } else {
          if(cache[keys[i]]?.componentInstance?.$children?.length > 0) {
            const childList = cache[keys[i]].componentInstance.$children
            if (childList?.length > 0) {
              childList.forEach(item => {
                const childObj = item?.$options?.parent
                cleanCacheAndKey(childObj, nameList, level + 1)
              })
            }
          }
        }
      }
    }
  }
}
